module.exports = __webpack_public_path__ + "img/xss_comments-1.7542ed3d.jpeg";